import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';

export interface FlexProps {
  wrap?: boolean;
}

const Flex = styled('div', {
  shouldForwardProp: prop => isPropValid(prop) && prop !== 'wrap',
})<FlexProps>`
  display: flex;
  align-items: center;
  ${({ wrap }) => (wrap ? 'flex-wrap: wrap;' : '')}
`;

export default Flex;
